import { render } from "./LockersComponent.vue?vue&type=template&id=28682e82"
import script from "./LockersComponent.vue?vue&type=script&lang=js"
export * from "./LockersComponent.vue?vue&type=script&lang=js"

import "./LockersComponent.vue?vue&type=style&index=0&id=28682e82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__